/**
 * Main JavaScript File
 */

// Template Parts
import { header } from './template-parts/header/header'

// ACF Blocks
import { initTestimonialsSlider } from './template-parts/blocks/testimonials-slider'
import { initHeroBannerSlider } from './template-parts/blocks/hero-banner-slider'
import { initLogosSlider } from './template-parts/blocks/logos-slider'
import { initFaqArchive } from './template-parts/blocks/faq-archive'
import { initIntegrationsArchive } from './template-parts/blocks/integrations-archive'
import { initPricingPlans } from './template-parts/blocks/pricing-plans'
import { initPartnersDirectory } from './template-parts/blocks/partners-directory'


import { videoBlock, videoOrganizations , videoBlockPopup } from './template-parts/blocks/video'
import { counterNumbers } from './template-parts/blocks/counter-numbers'
import { initTeamBlock } from './template-parts/blocks/team-block'
import { blogLoadMore } from './template-parts/blocks/blog-loadmore'
import { initContentImageSlider } from './template-parts/blocks/content-image-slider'
import { initContentImageTabs } from './template-parts/blocks/content-image-tabs'

// Components
import { appearence } from './components/animations/appearence'
import { scrollToAnchor } from './components/animations/scroll-to-anchor'
import { popup } from './components/popup'

// Utils
import 'bootstrap/js/src/collapse'

// Components
appearence()
scrollToAnchor()

// Template Parts
header()

popup()

// ACF Blocks
initTestimonialsSlider()
initHeroBannerSlider()
initLogosSlider()
videoBlock()
videoOrganizations()
videoBlockPopup()
counterNumbers()
initTeamBlock()
blogLoadMore()
initFaqArchive()
initIntegrationsArchive()
initContentImageSlider()
initPricingPlans()
initPartnersDirectory()
initContentImageTabs();

// Utils
// videoSize()
